<template>

<div id="app" v-if="i18nLoaded">

  <div id="page-container">

    <div id="header-container">
      <div id="logo-container">
        <a :href="mwnf_website" target="_blank">
          <img src="./assets/logo.png" alt="MWNF Logo">
        </a>
      </div>
      <!-- Alt header for pages other than home -->
      <div id="title-container">
        <a :href="dia_website">
          <span id="title">{{ $i18n.t("db_partner_ISL_Capital") }}</span>
        </a>
      </div>
      <div id="portals-search-container">
        <div id="portals-container">
          <div id="portal-links">
            <a id="portal-link" :href="mwnf_website" target="_blank">
              {{ $i18n.t("portal_link") }}
            </a>
            <span v-if="!lessThan769"> | </span>
            <!-- <router-link :to="{ name: 'home' }" v-if="!lessThan769">
              {{ $i18n.t("back_to_section") }}
            </router-link>  -->
            <a :href="dia_website" v-if="!lessThan769">
              {{ $i18n.t("back_to_section") }}
            </a>
          </div>
        </div>
        <div id="site-language-container">
          <select
            id="site-language-select" 
            v-model="siteLanguage">
            <option v-for="(language, key) in siteLanguages" :key="language" :value="key"
              :dir="key === 'ar' ? 'rtl' : 'ltr'">
              {{ language }}
            </option>
          </select>
        </div>
      </div>
    </div>

    <!-- Set up "views" for components -->
    <!-- Empty view is where main components for other pages is inserted -->
    <!-- Refer to route.js -->
    <router-view name="banner" :siteLanguage="siteLanguage"></router-view>
    <router-view name="navigation" :siteLanguage="siteLanguage"></router-view>
    <router-view name="sub-banner" :siteLanguage="siteLanguage"></router-view>
    <router-view :siteLanguage="siteLanguage"></router-view>

    <div id="footer-container">
      <div id="footer-links">
        <a :href="mwnf_website + '/atrium_about.php'" target="_blank">{{ $i18n.t("footer1") }}</a> |
        <a :href="mwnf_website + '/atrium_ourteam.php'" target="_blank">{{ $i18n.t("footer2") }}</a> |
        <a :href="mwnf_website + '/mwnf_legal.php'" target="_blank">{{ $i18n.t("footer3") }}</a> |
        <a :href="mwnf_website + '/mwnf_credit.php'" target="_blank">{{ $i18n.t("footer4") }}</a> |
        <a :href="mwnf_website + '/cookie_policy.php'" target="_blank">{{ $i18n.t("cookie_policy") }}</a> |
        <span>{{ $i18n.t("footer5") }}{{ currentYear }}</span>
      </div>
      <div id="social-media">
        <a href="https://www.youtube.com/channel/UC5X2a5jDFyIfTEV5prWNF5Q" target="_blank">
          <font-awesome-icon :icon="['fab', 'square-youtube']" />
        </a>
        <a href="https://twitter.com/mwnf_org/" target="_blank">
          <font-awesome-icon :icon="['fab', 'square-x-twitter']" />
        </a>
        <a href="http://www.facebook.com/pages/Museum-With-No-Frontiers/370544525423" target="_blank">
          <font-awesome-icon :icon="['fab', 'square-facebook']" />
        </a>
        <a href="https://www.instagram.com/museumwithnofrontiers/" target="_blank">
          <font-awesome-icon :icon="['fab', 'square-instagram']" />
        </a>
        <a href="https://www.weibo.com/6540990409/profile?topnav=1&wvr=6&is_all=1" target="_blank">
          <font-awesome-icon :icon="['fab', 'weibo']" />
        </a>
        <a href="https://www.linkedin.com/company/museum-with-no-frontiers/" target="_blank">
          <font-awesome-icon :icon="['fab', 'linkedin']" />
        </a>
      </div>
    </div>
  
  </div>

</div>

</template>



<script>

import { loadLocaleMessages } from "./i18n.js";
import media from "./mixins/media.js";
export default {
  name: "App",
  mixins: [media],
  data() {
    return {
      i18nLoaded: false,
      siteLanguage: "en",
      siteLanguages: {
        en: "English",
        es: "Español",
        fr: "Français",
        ar: "العربية"
      },
      lessThan599: window.matchMedia("(max-width: 599px)").matches,
      lessThan769: window.matchMedia("(max-width: 769px)").matches,
      displaySearchBar: false,
      searchInput: "",
      currentYear: new Date().getFullYear(),
      mwnf_website: process.env.VUE_APP_MWNF_WEBSITE,
      dia_website: process.env.VUE_APP_DIA_WEBSITE,
    }
  },
  watch: {
    "$route" () {
      loadLocaleMessages(this.siteLanguage);
    },
    "siteLanguage" () {
      loadLocaleMessages(this.siteLanguage);
    }
  },
  mounted() {
    loadLocaleMessages(this.siteLanguage).then(() => {
      this.i18nLoaded = true;
    });
  }
}

</script>



<style lang="scss">

/* See borders while designing pages */
// * {
//   border: 1px dashed red;
// }

* {
  margin: 0;
  padding: 0;
  font-family: "Roboto", sans-serif;
  font-size: 100%;
}
*, ::before, ::after {
  box-sizing: border-box;
}

body {
  @include flex-center;
  align-items: flex-start;
  background-color: $background-color;
  overflow-x: hidden;
}

#page-container {
  @include flex-center;
  flex-direction: column;
  justify-content: flex-start;
  width: 1350px;
  max-width: 1350px;
  box-shadow: 0 2px 8px 2px $shadow-grey;
}

#header-container {
  @include flex-center;
  position: relative;
  justify-content: space-between;
  height: 80px;
  width: 100%;
  color: $text-color;
  background-color: $theme-medium;
}
  #logo-container {
    @include flex-center;
    padding: 0 10px;
    z-index: 8;
  }
  #title-container {
    @include flex-center;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    max-width: 45%;
    font-size: 190%;
    text-align: center;
    z-index: 10;
    padding: 10px;
  }
    #title-container a {
      @include flex-center;
      flex-direction: column;
      color: #4C420E;
      text-decoration: none;
    }
    #title {
      line-height: 100%;
      margin-top: 4px;
    }
  #portals-search-container {
    @include flex-center;
    flex-direction: column;
    align-items: flex-end;
    padding: 0 10px;
    font-size: 14px;
    z-index: 10;
  }
    #portals-container a {
      color: $text-color;
      text-decoration: none;
      padding: 0 10px;
    }
    #site-language-container {
      padding-top: 10px;
      padding-right: 5px;
    }
    
#footer-container {
  @include flex-center;
  height: 40px;
  width: 100%;  
  font-size: 14px;
  color: $text-color;
  background-color: $theme-medium;
  text-align: center;
}
  #footer-container a {
    color: $text-color;
    text-decoration: none;
  }
  #footer-links,
  #social-media {
    padding: 0 15px;
  }
    #social-media a {
      margin: 0 5px;
    }

@media only screen and (max-width: 1349px) {
  #page-container {
    width: 100vw;
  }
}

@media only screen and (max-width: 1199px) {
  #title-container {
    font-size: 175%;
  }
}

@media only screen and (max-width: 974px) {
  #footer-container {
    flex-direction: column;
    height: 65px;
  }
    #footer-links,
    #social-media {
      width: 100%;
    }
}

@media only screen and (max-width: 849px) {
  #title-container {
    font-size: 150%;
  }
}

@media only screen and (max-width: 724px) {
  #logo-container {
    width: 120px;
  }
    #logo-container img {
      @include image-scale;
    }
    #title-container {
      font-size: 135%;
      text-align: center;
    }
    #portals-search-container {
      font-size: 13px;
    }
      #site-language-container {
        padding-top: 5px;
      }
   #footer-container {
    height: 90px;
    line-height: 22px;
  }
}

@media only screen and (max-width: 599px) {
  #header-container {
    position: sticky;
    top: 0;
    height: 65px;
    z-index: 90;
  }
  #logo-container {
    width: 110px;
    padding-left: 0;
    margin-left: 45px;
  }
  #portals-search-container {
    padding-right: 12px;
  }
    #portals-container {
      @include flex-center;
      flex-direction: column;
      align-items: flex-end;
    }
      #portal-links {
        display: flex;
        flex-direction: column;
        align-items: flex-end;
      }
      #portals-container a {
        font-size: 85%;
        padding: 4px 0;
      }
        #portals-container #mwnf-link {
          padding-right: 0;
        }
      #portals-container button {
        @include button-styles;
        color: $text-color;
        margin-top: 4px;
        font-size: 18px;
      }
}

@media only screen and (max-width: 499px) {
  #header-container {
    height: 80px;
  }
    #logo-container {
      width: 90px;
      margin-left: 36px;
    }
}

@media only screen and (max-width: 399px) {
  #title-container {
    height: 60px;
    font-size: 100%;
  }
  #logo-container {
    width: 80px;
    margin-left: 32px;
  }
  #portals-search-container {
    padding-right: 8px;
  }
  #footer-container {
    height: 110px;
    line-height: 24px;
  }
}

@media print {
  #header-container,
  #footer-container {
    display: none;
  }
  #page-container {
    width: auto;
    max-width: none;
    box-shadow: none;
  }
}

</style>
